import { j as json } from "../../../../../chunks/index2.js";
import { f as findCustomerByEmail, g as getLatestPaymentIntent } from "../../../../../chunks/stripe.js";
const GET = async ({ url }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  if (email) {
    const customer = await findCustomerByEmail(email);
    const paymentIntent = await getLatestPaymentIntent(customer.id);
    const success = paymentIntent.status === "succeeded";
    return json(
      {
        success
      },
      {
        status: success ? 200 : 403
      }
    );
  }
  return json({ error: "No email provided" }, { status: 400 });
};
export {
  GET
};
